import React, { useState, useEffect, useContext } from "react";
import jMoment from "moment-jalaali";
import Input from "../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";

import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress, IconButton } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const Sorting = (props) => {
  const [sortName, setSortName] = useState({
    name: "تاریخ شروع",
    value: "startDate",
  });
  const [sortDir, setSortDir] = useState({ name: "نزولی", value: "DESC" });
  useEffect(() => {
    props.sortUpdater(sortName, sortDir);
  }, [sortName, sortDir]);

  const namesList = [
    { name: "تاریخ شروع", value: "startDate" },
    { name: "شماره جعبه", value: "boxNumber" },
    { name: "وضعیت تاخیر", value: "delation" },
    { name: "تاریخ پایان", value: "finishDate" },
    { name: "آخرین ورود", value: "lastEntryDate" },
    { name: "آخرین خروج", value: "lastExitDate" },
    { name: "پیش بینی خروج", value: "predictionDate" },
  ];
  const dirList = [
    { name: "صعودی", value: "ASC" },
    { name: "نزولی", value: "DESC" },
  ];

  return (
    <>
      <Grid md={6} xs={12}>
        <Autocomplete
          options={namesList}
          getOptionLabel={(option) => option.name}
          fullWidth
          id="sort-name"
          disableClearable
          value={sortName}
          onChange={(event, newValue) => {
            setSortName(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} label="ترتیب" variant="standard" />
          )}
        />
      </Grid>
      <Grid md={6} xs={12}>
        <Autocomplete
          options={dirList}
          getOptionLabel={(option) => option.name}
          fullWidth
          id="sort-dir"
          disableClearable
          value={sortDir}
          onChange={(event, newValue) => {
            setSortDir(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} label="جهت" variant="standard" />
          )}
        />
      </Grid>
    </>
  );
};

export default Sorting;
